module.exports = __webpack_public_path__ + "img/K73-HQ.393241af.png";